import { TitleFull as Title } from '@warehouse/title/core';
import { fromBasic, getTitleData } from '../../../utils/titleGetProperty';

export default function getDefaultLocale(title: Title | undefined): string | undefined {
	if (!title) return undefined;
	return getTitleData<string>(title, fromBasic(['localizedInfos', '__default', 'language', 'displayValue']));
}
